import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultCompanyData, getCompanyById, updateCompany, createCompany } from '@/api/companies';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getPincodes, getPincodeById } from '@/api/pincode';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultCompanyData);
    this.loading = false;
    this.pincodeList = [];
    this.rules = {
      addressLine1: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      pincodeId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      gstNumber: {
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter a valid GST number',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultCompanyData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getCompanyById(id);
      // fetch pincode
      await this.getPincodeById(data.pincodeId);
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getPincodeList(query) {
    try {
      if (query && query.length > 2) {
        this.pincodeList = await getPincodes(getQuery({
          pincode: query,
          filter: {
            pincode: '$starts'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getPincodeById(pincodeId) {
    try {
      if (pincodeId) {
        const data = await getPincodeById(pincodeId);
        this.pincodeList = [data];
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async updateLocation(pincodeId) {
    if (pincodeId) {
      const pincode = await getPincodeById(pincodeId);
      this.formData.pincode = {
        id: pincode.id
      };
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      await this.updateLocation(this.formData.pincodeId);
      if (this.isEdit) {
        await updateCompany(this.formData.id, this.formData);
      } else {
        await createCompany(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Address saved',
        type: 'success',
        duration: 2000
      });
      router.push('/companies/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'CompanyDetail',
  components: {}
})], default_1);
export default default_1;